import React from 'react';
import './MetricTooltip.styl';

interface MetricTooltipProps {
  header: string;
  tooltip: React.ReactElement | string;
  link: string;
}

const MetricTooltip: React.FC<MetricTooltipProps> = ({header, tooltip, link}) => {
  return (
    <div className="metric-tooltip">
      <h3>{header}</h3>
      <p>{tooltip}</p>
      <a href={link} target="_blank" rel="noreferrer">
        How is this calculated?
      </a>
    </div>
  );
};

export default MetricTooltip;
